<template>
<!--Componente del prospecto-->
<form  class="cardForm" v-on:submit.prevent="submitForm"> 
    <div class="loginIconContainer">
            <div class="loginIcon">
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#ffff" class="bi bi-person-fill" viewBox="0 0 16 16">
                    <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"></path>
                </svg>
            </div>
            </div>
    <br>     
    <center><h2>Ingresa a tu cuenta</h2></center>
    <general @datageneralalumno="getDatageneralalumno">

    </general>
    <div v-show="para">
        <p style="color:red">Ese correo electrónico o contraseña no coincide con nuestros registros. Inténtelo de nuevo.</p>
    </div>
    <button type="sumbit" class="cmp-button" :disabled="btn" :class="{ spanap : showbtnsend }">Iniciar Sesíon</button>            
    </form>
</template>
<!--Componente del prospecto-->
<style scoped>
.cardForm {

  border-radius: 6px;
  box-shadow: 0 11px 24px 0 #b0d3eb;
  border: solid 1px #5eabe0;
  background-color: white;
  border-top: solid 8px #0d6eba;
  padding: 24px;
  width: 40%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 45px;
  
  
  }
  @media only screen and (max-width: 880px) {
      .cardForm {
        width: 80%;
      }
  }

.inputControl {
  position: relative;
   margin-top: 30px;
    display: flex;
}
label {
    color: #0d6eba;
    background: white;
    font-size: 14px;
    font-weight: bold;
    position: absolute;
    top: -9px;
    left: 9px;
    padding: 0 8px;
  }

  input {
    border-radius: 6px;
    border: solid 1px black;
    background-color: white;
    padding: 10px 16px;
    padding-right: 35px;
    width: 100%;
    font-size: 16px;
    color:  #505050;
  }

   button {
    width: 100%;
    margin-top: 20px;
    text-align: center;
  }

   h2 {
      margin-top: 5px;
      margin-bottom: 25px;
      color:#0d6eba;
      font-weight:700;
      font-size:24px;
    }
    .cmp-button{
        appearance:none;
        border-radius: 3px;
        cursor:pointer;
        font-size:18px;
        padding:9pt 14px 14px;
        text-align:center;
        font-weight:500;
        background-color:#0d6eba;
        border: 1px solid #0d6eba;
        color:white;
        transition:background-color .4s ease-out,color .3s ease-out,border .4s ease-out;
    }
    .spanap {
    display: none;
    }
.loginIcon,.loginIconContainer {
    align-items: center;
    display: flex;
    justify-content: center;
}

.loginIcon {
    background: #000;
    border-radius: 50%;
    height: 38px;
    width: 38px
}

.loginContainer {
    background-color: #fff;
    border: 0 solid #5eabe0;
    border-radius: 6px;
    border-top: 8px solid #0d6fb8;
    -webkit-box-shadow: 0 11px 24px 0 #b0d3eb;
    box-shadow: 0 11px 24px 0 #b0d3eb;
    margin-bottom: 45px;
    margin-left: auto;
    margin-right: auto;
    padding: 24px;
    text-align: center;
    width: 40%
}
</style>
<script>
//Componente datosgeneral.vue
import General from '../alumno/DatosgeneralesAlumno.vue'
import axios from 'axios';
export default {
  name: 'AlumnoformComponent',
  props:['idsch','tpsch','cicloi'],
  components: {
   General
  },
  data(){
        return {
            para:false,
            btn: false,
            showbtnsend: false,
            nivel: this.tpsch,
            ciclo: this.cicloi,
                form: {
                CorreoElectronico: null,
                Pass: null
            },
            url:process.env.VUE_APP_URL,
            urlgeneral:process.env.VUE_APP_URL_GENERAL,
            urlpost:process.env.VUE_APP_URL_POST,
            urlhub:process.env.VUE_APP_URL_GET_HUB
            
        };
    },
     methods: {
     getDatageneralalumno: function(paramsAlumno) {
      console.log(paramsAlumno);
      this.form.Pass = paramsAlumno.Pass;
      this.form.CorreoElectronico = paramsAlumno.correoalumno;
    },
    submitForm(){  
    //this.btn=true;
    //this.showbtnsend = true;
    axios.post(this.urlgeneral+"/api/loginprospeccion", this.form)
        .then(response => {
            console.log(response.data.message);
            if(response.data.message == "OK"){
                this.para = false;
                var information = new Object();
                information.email = response.data.data[0].email;
                information.phone = response.data.data[0].phone;
                information.portal = response.data.data[0].portal;
                information.schooldescription = response.data.data[0].schooldescription;
                information.secondname = response.data.data[0].secondname;
                information.lastname = response.data.data[0].lastname;
                information.typeschool = response.data.data[0].typeschool;
                information.typeuser = response.data.data[0].typeuser;
                information.schoolid = response.data.data[0].schoolid;
                information.name = response.data.data[0].name;
                localStorage.setItem("dataForm", JSON.stringify([information]));
        let configdos = {
        headers: {
        'Content-type': "application/json",
        }
        }
        this.recordseedhub = {
        fields:[
            {
                name: "email",
                value: this.form.CorreoElectronico
            },
            {
                name: "firstname",
                value: response.data.data[0].name
            },
            {
                name: "lastname",
                value: response.data.data[0].lastname
            },
            {
                name: "apellido_materno__c",
                value: response.data.data[0].secondname
            },
            {
                name: "mobilephone",
                value: response.data.data[0].phone
            },
            {
                name: "ea_tipo_usuario",
                value:response.data.data[0].typeuser
            }
         ],
         context:
            {
                pageUri: "https://educando.unitec.mx/registro",
                pageName: "UNITEC | Registro Educando"
            }
     }
         axios.post(this.urlhub, this.recordseedhub,configdos).then((result2) => {
            console.log(result2.data.inlineMessage);
            var tipousuario = "";
                if(response.data.data[0].typeuser == 2){
                    tipousuario = "alumno";
                }
                if(response.data.data[0].typeuser == 3){
                    tipousuario = "tutor";
                }
                if(response.data.data[0].typeuser == 4){
                    tipousuario = "docente";
                }
                var cookieprospecto = this.form.CorreoElectronico+"|"+tipousuario;
                console.log(cookieprospecto);
            if(result2.data.inlineMessage == "Thanks for submitting the form." && response.data.data[0].typeuser == 2){
                document.cookie = "educando="+cookieprospecto;
                window.location.href = "https://educando-qa.atencionunitec.mx/preparatoria";
            }
            if(result2.data.inlineMessage == "Thanks for submitting the form." && response.data.data[0].typeuser == 1){
                document.cookie = "educando="+ cookieprospecto;
                window.location.href = "https://educando-qa.atencionunitec.mx/secundaria";
            }
        }).catch(error => {
            console.log("El Error the hubspot: ",error.message);
        });
            }else{
                this.para = true;
            }
        }).catch(error => {
            console.log("El Error en el login es: ",error.message);
        });
    },
    }
}
</script>